import { FormEvent, useMemo } from "react"
import { createPortal } from "react-dom"
import classNames from "classnames"

import modalStyles from "assets/scss/index.module.scss"
import { ReactComponent as IconExclamationTriangle } from "assets/svg/exclamation-triangle.svg"

import { ModalLayout } from "layouts/ModalLayout"

import styles from "./index.module.scss"

interface AlertRuleToggleConfirmationModalProps {
  isActive: boolean
  thermostatSn?: string
  targetDescription?: string
  impactMessage?: string | null
  onConfirm: (event: FormEvent<HTMLElement>) => void
  onCancel: () => void
}

export const AlertRuleToggleConfirmationModal = ({
  isActive,
  thermostatSn,
  targetDescription,
  impactMessage,
  onConfirm,
  onCancel,
}: AlertRuleToggleConfirmationModalProps) => {
  const actionLabel = isActive ? "Deactivate" : "Activate"
  const { confirmationMessage, resolvedImpactMessage } = useMemo(() => {
    let message: string
    const isThermostatScoped = Boolean(targetDescription || thermostatSn)

    if (isThermostatScoped) {
      message = `Are you sure you want to ${actionLabel.toLowerCase()} this alert rule for the Thermostat?`
    } else {
      message = `Are you sure you want to ${actionLabel.toLowerCase()} this alert rule entirely?`
    }

    const defaultMessage = isThermostatScoped
      ? null
      : `It will be ${isActive ? "disabled" : "enabled"} for all Thermostats.`

    return {
      confirmationMessage: message,
      resolvedImpactMessage: impactMessage === undefined ? defaultMessage : impactMessage,
    }
  }, [actionLabel, impactMessage, isActive, targetDescription, thermostatSn])

  return (
    <>
      {createPortal(
        <ModalLayout
          width="450px"
          onConfirm={onConfirm}
          onCancel={onCancel}
          className={styles.alertRuleConfirmationModal}
        >
          <div className={classNames(modalStyles.modalContent, modalStyles.center)}>
            <div className={styles.alertRuleConfirmationIcon}>
              <IconExclamationTriangle />
            </div>
            <h3 className={modalStyles.modalTitle}>{actionLabel}</h3>
            <div className={modalStyles.modalMessage}>{confirmationMessage}</div>
            {resolvedImpactMessage && (
              <div className={classNames(modalStyles.modalMessage, styles.impactMessage)}>{resolvedImpactMessage}</div>
            )}
          </div>
        </ModalLayout>,
        document.body,
      )}
    </>
  )
}
